module.exports = __webpack_public_path__ + "img/fblc-标准赛区.d3721a35.jpg";